export const NVR_ADVANCED_NAV = [
  { id: "display", label: "Display" },
  { id: "recording", label: "Recording" },
  { id: "hardDrive", label: "Hard Drive" },
  { id: "event", label: "Event" },
  { id: "network", label: "Network" },
];

export const NVR_ADVANCED_CHANNELS = [
  { value: "CH1", label: "CH1" },
  { value: "CH2", label: "CH2" },
];

export const NVR_ADVANCED_SCENES = [
  { value: "default", label: "Default" },
];

export const DEFAULT_NVR_IMAGE_SETTINGS = {
  scene: "default",
  brightness: 50,
  saturation: 50,
  contrast: 50,
  sharpness: 50,
};
